/** Simple centered Bootstrap spinner used while data loads. */
export default function Loading({ label = 'Loading…' }) {
  return (
    <div
      style={{
        display: 'flex',
        height: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: '1rem',
      }}
    >
      <div className="spinner-border" role="status" style={{ width: 50, height: 50 }}>
        <span className="visually-hidden">{label}</span>
      </div>
    </div>
  );
}
